import AdminSettingsForm from './AdminSettingsForm'

export default AdminSettingsForm
